const img = require('./none.svg'); export default img;